<form [formGroup]="contactInformationForm" class="form-section" >
    <div class="" fxLayout="row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row" fxLayout.sm="row"
      fxLayout.xs="column" fxLayoutAlign="start stretch" fxLayoutGap="15px">
      <div fxLayout="column" fxFlex.xl="100" fxFlex.lg="100" fxFlex.md="100" fxFlex.sm="100" fxFlex.xs="100"
        fxFlexFill fxLayoutAlign="start stretch">
        <!-- <div class="custom-form-group"
        >
        <label class="custom-label" for="">Select state*<span class="star">*</span></label>
        <div class="custom-form-control">
          <mat-form-field appearance="outline">
            <mat-select placeholder="Select any type" formControlName="state">
              <mat-option disabled=""> Select state </mat-option>
              <mat-option [value]="'Australian Capital Territory'">Australian Capital Territory</mat-option>
              <mat-option [value]="'New south wales'">New south wales</mat-option>
              <mat-option [value]="'Northern Territory'">Northern Territory</mat-option>
              <mat-option [value]="'Queensland'">Queensland</mat-option>
              <mat-option [value]="'South australia'">South australia</mat-option>
              <mat-option [value]="'Western australia'">Western australia</mat-option>
              <mat-option [value]="'Victoria'">Victoria</mat-option>
            </mat-select>
            <mat-error *ngIf="state.invalid && ( state.dirty || state.touched )">
              <span>State is required</span>
            </mat-error>
          </mat-form-field>
        </div>
      </div> -->
        <ul class="signup_ul_form">
          <li *ngIf="subPlanDetails?.type =='SUPPLIER' || subPlanDetails?.type =='PRACTICE'">
            <!-- First Name-INPUT -->
            <div class="custom-form-group">
              <label class="custom-label" for="">First Name
                <span class="star" style="display: inline-block !important;">*</span><span
                  class="star">*</span></label>
              <div class="custom-form-control">
                <mat-form-field appearance="outline">
                  <input matInput placeholder="Enter first name" formControlName="fName">
                  <mat-error *ngIf="fName.invalid && ( fName.dirty || fName.touched )">
                    <span>First name is required</span>
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
          </li>
          <li *ngIf="subPlanDetails?.type =='SUPPLIER'|| subPlanDetails?.type =='PRACTICE'">
            <!-- Middle-INPUT -->
            <div class="custom-form-group">
              <label class="custom-label" for="">Middle Name<span class="star">*</span></label>
              <div class="custom-form-control">
                <mat-form-field appearance="outline">
                  <input matInput placeholder="Enter middle name" formControlName="mName">
                  <!-- <mat-error *ngIf="mName.invalid && ( mName.dirty || mName.touched )">
                    <span>Middle name  is required</span>
                  </mat-error> -->
                </mat-form-field>
              </div>
            </div>
          </li>
          <li *ngIf="subPlanDetails?.type =='SUPPLIER'|| subPlanDetails?.type =='PRACTICE'">
            <!-- Last-INPUT -->
            <div class="custom-form-group">
              <label class="custom-label" for="">Last Name
                <span class="star" style="display: inline-block !important;">*</span><span
                  class="star">*</span></label>
              <div class="custom-form-control">
                <mat-form-field appearance="outline">
                  <input matInput placeholder="Enter last name" formControlName="lName">
                  <mat-error *ngIf="lName.invalid && ( lName.dirty || lName.touched )">
                    <span>Last name  is required</span>
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
          </li>
          <li *ngIf="subPlanDetails?.type =='SUPPLIER'|| subPlanDetails?.type =='PRACTICE'">
            <!-- Business Email Address-INPUT -->
            <div class="custom-form-group">
              <label class="custom-label" for="">Business Email Address
                <span class="star" style="display: inline-block !important;">*</span><span
                  class="star">*</span></label>
              <div class="custom-form-control">
                <mat-form-field appearance="outline">
                  <input matInput placeholder="Enter business email address"
                    formControlName="businessEmail">
                  <mat-error
                    *ngIf="businessEmail.invalid && ( businessEmail.dirty || businessEmail.touched )">
                    <span>Business email address is required</span>
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
          </li>
          <li *ngIf="subPlanDetails?.type =='SUPPLIER'|| subPlanDetails?.type =='PRACTICE'">
            <!-- Business Phone Number-INPUT -->
            <div class="custom-form-group">
              <label class="custom-label" for="">Business Phone Number
                <span class="star" style="display: inline-block !important;">*</span><span
                  class="star">*</span></label>
              <div class="custom-form-control">
                <mat-form-field appearance="outline">
                  <input type="text" matInput placeholder="Enter business phone number"
                    formControlName="businessPhoneNumber">
                  <mat-error
                    *ngIf="businessPhoneNumber.invalid && ( businessPhoneNumber.dirty || businessPhoneNumber.touched )">
                    <span>Business phone number  is required</span>
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
          </li>
          <li *ngIf="subPlanDetails?.type =='SUPPLIER'|| subPlanDetails?.type =='PRACTICE'">
            <!-- Fax Number-INPUT -->
            <div class="custom-form-group">
              <label class="custom-label" for="">Fax Number
                <span class="star" style="display: inline-block !important;"></span>
              </label>
              <div class="custom-form-control">
                <mat-form-field appearance="outline">
                  <input type="text" matInput placeholder="Enter fax number" formControlName="faxNumber">
                  <!-- <mat-error *ngIf="faxNumber.invalid && ( faxNumber.dirty || faxNumber.touched )">
                    <span>Please provide a valid Fax Number</span>
                  </mat-error> -->
                </mat-form-field>
              </div>
            </div>
          </li>
          <li>
            <!-- Alternate Email-INPUT -->
            <div class="custom-form-group">
              <label class="custom-label" for="">Alternate email<span class="star"></span></label>
              <div class="custom-form-control">
                <mat-form-field appearance="outline">
                  <input type="email" matInput placeholder="Enter alternate email"
                    formControlName="altEmail">
                  <mat-error *ngIf="altEmail.invalid && (altEmail.dirty || altEmail.touched )">
                    <span>Alternate
                      email is
                      required</span>
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
          </li>
          <li>
            <!-- Alternate PHone No-INPUT -->
            <div class="custom-form-group">
              <label class="custom-label" for="">Alternate Phone number<span class="star"></span></label>
              <div class="custom-form-control">
                <mat-form-field appearance="outline">
                  <input type="text" matInput placeholder="Enter alternate phone No"
                    formControlName="altPhoneNo">
                  <mat-error *ngIf="altPhoneNo.invalid && ( altPhoneNo.dirty || altPhoneNo.touched )">
                    <span>Alternate phone number  is required</span>
                  </mat-error>
                  <!-- <mat-error *ngIf="!altPhoneNo.pattern">
                    <span> please valid alternate Phone number</span>
                  </mat-error> -->
                  <!-- <div *ngIf="f.password.errors.minlength">Password must be at least 6 characters</div> -->
                </mat-form-field>
              </div>
            </div>
          </li>
          <li>
            <!-- Address line 1-INPUT -->
            <div class="custom-form-group">
              <label class="custom-label" for="">Address<span class="star"
                  style="display: inline-block !important;">*</span></label>
              <div class="custom-form-control">
                <mat-form-field appearance="outline">
                  <input matInput placeholder="search for location" formControlName="address"
                    autocorrect="off" autocapitalize="off" spellcheck="off" type="text" #search>
                  <!-- <input  matInput  (keydown.enter)="$event.preventDefault()" formControlName="address" placeholder="Search Nearest Location" autocorrect="off" autocapitalize="off" spellcheck="off" type="text" #search> -->
                  <mat-error *ngIf="address.invalid && ( address.dirty || address.touched )">
                    <span>Address  is required</span>
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
          </li>
          <li>
            <!-- Address line 2-INPUT -->
            <div class="custom-form-group">
              <label class="custom-label" for="">Address line 1
                <span class="star" style="display: inline-block !important;"></span>
              </label>
              <div class="custom-form-control">
                <mat-form-field appearance="outline">
                  <input matInput placeholder="Enter address line 1" formControlName="address_line_one">
                  <!-- <mat-error
                    *ngIf="address_line_one.invalid && ( address_line_one.dirty || address_line_one.touched )">
                    <span>Address line 1 is required</span>
                  </mat-error> -->
                </mat-form-field>
              </div>
            </div>
          </li>
          <li>
            <!-- Address line 2 -->
            <div class="custom-form-group">
              <label class="custom-label" for="">Address line 2</label>
              <div class="custom-form-control">
                <mat-form-field appearance="outline">
                  <input matInput placeholder="Enter address line 2" formControlName="address_line_two">
                  <!-- <mat-error
                    *ngIf="address_line_two.invalid && ( address_line_two.dirty || address_line_two.touched )">
                    <span>Address line 2 is required</span>
                  </mat-error> -->
                </mat-form-field>
              </div>
            </div>
          </li>
          <li>
            <!-- City-INPUT -->
            <div class="custom-form-group">
              <label class="custom-label" for="">City
                <span class="star" style="display: inline-block !important;">*</span>
              </label>
              <div class="custom-form-control">
                <mat-form-field appearance="outline">
                  <input matInput placeholder="Enter city" formControlName="city">
                  <mat-error *ngIf="city.invalid && ( city.dirty || city.touched )">
                    <span>City is required</span>
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
          </li>
          <li>
            <!-- Landmark -INPUT -->
            <div class="custom-form-group">
              <label class="custom-label" for="">Landmark</label>
              <div class="custom-form-control">
                <mat-form-field appearance="outline">
                  <input matInput placeholder="Enter landmark" formControlName="land_mark">
                  <!-- <mat-error *ngIf="land_mark.invalid && ( land_mark.dirty || land_mark.touched )">
                <span>Landmark is required</span>
              </mat-error> -->
                </mat-form-field>
              </div>
            </div>
          </li>
          <li>
            <!-- State-INPUT -->
            <div class="custom-form-group">
              <label class="custom-label" for="">Country
                <span class="star" style="display: inline-block !important;">*</span>
              </label>
              <div class="custom-form-control">
                <mat-form-field appearance="outline">
                  <input matInput placeholder="Enter country" formControlName="country">
                  <mat-error *ngIf="country.invalid && ( country.dirty || country.touched )">
                    <span>Country is required</span>
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
          </li>
          <li>
            <!-- State-INPUT -->
            <div class="custom-form-group">
              <label class="custom-label" for="">State
                <span class="star" style="display: inline-block !important;">*</span>
              </label>
              <div class="custom-form-control">
                <mat-form-field appearance="outline">
                  <input matInput placeholder="Enter state" formControlName="state">
                  <mat-error *ngIf="state.invalid && ( state.dirty || state.touched )">
                    <span>State is required</span>
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
          </li>
          <li>
            <!-- Zipcode-INPUT -->
            <div class="custom-form-group">
              <label class="custom-label" for="">Zip code
                <span class="star" style="display: inline-block !important;">*</span>
              </label>
              <div class="custom-form-control">
                <mat-form-field appearance="outline">
                  <input type="text" matInput placeholder="Enter Zip code" formControlName="zipcode">
                  <mat-error *ngIf="zipcode.invalid && ( zipcode.dirty || zipcode.touched )"> <span>Zip code
                      is
                      required</span>
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="" fxLayout="row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row" fxLayout.sm="row"
      fxLayout.xs="column" fxLayoutAlign="start stretch" fxLayoutGap="0px"
      *ngIf="subPlanDetails?.type =='SUPPLIER'|| subPlanDetails?.type =='PRACTICE'">
      <div fxLayout="column" fxFlex.xl="100" fxFlex.lg="100" fxFlex.md="100" fxFlex.sm="100" fxFlex.xs="100"
        fxFlexFill>
        <div class="account_branch">
          <div class="or">
            <span>Secondary Contact Info</span>
          </div>
        </div>
      </div>
    </div>
    <div class="" fxLayout="row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row" fxLayout.sm="row"
      fxLayout.xs="column" fxLayoutAlign="start stretch" fxLayoutGap="15px"
      *ngIf="subPlanDetails?.type =='SUPPLIER'|| subPlanDetails?.type =='PRACTICE'">
      <div fxLayout="column" fxFlex.xl="100" fxFlex.lg="100" fxFlex.md="100" fxFlex.sm="100" fxFlex.xs="100"
        fxFlexFill>
        <ul class="signup_ul_form">
          <li>
            <!-- Contact name-INPUT -->
            <div class="custom-form-group">
              <label class="custom-label" for="">Contact Name
                <span class="star" style="display: inline-block !important;"></span>
              </label>
              <div class="custom-form-control">
                <mat-form-field appearance="outline">
                  <input matInput placeholder="Enter contact name" formControlName="contactName">
                  <!-- <mat-error *ngIf="contactName.invalid && ( contactName.dirty || contactName.touched )">
                    <span>Contact name is required</span>
                  </mat-error> -->
                </mat-form-field>
              </div>
            </div>
          </li>
          <li>
            <!-- Email Address
          -INPUT -->
            <div class="custom-form-group">
              <label class="custom-label" for="">Email Address<span class="star"
                  style="display: inline-block !important;"></span></label>
              <div class="custom-form-control">
                <mat-form-field appearance="outline">
                  <input matInput placeholder="Enter email address" formControlName="emailTwo">
                  <!-- <mat-error *ngIf="emailTwo.invalid && ( emailTwo.dirty || emailTwo.touched )">
                    <span>Email is required</span>
                  </mat-error> -->
                </mat-form-field>
              </div>
            </div>
          </li>
          <li>
            <!-- Phone Number-INPUT -->
            <div class="custom-form-group">
              <label class="custom-label" for="">Phone Number<span class="star"
                  style="display: inline-block !important;"></span></label>
              <div class="custom-form-control">
                <mat-form-field appearance="outline">
                  <input matInput placeholder="Enter phone number" formControlName="phoneNoTwo">
                  <mat-error *ngIf="phoneNoTwo.invalid && ( phoneNoTwo.dirty || phoneNoTwo.touched )">
                    <span>Phone number Not Valid</span>
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
          </li>
        </ul>
      </div>

    </div>
    <div class="subscriber_stepper_btn">
      <button mat-button *ngIf="incompletelogin=='0'" (click)="moveBack()" class="mat_stepper_previous global-btn" 
         type="button">Back</button>
         <a style="display: block;" *ngIf="incompletelogin=='1'">&nbsp;</a>
      <button mat-button class="mat_stepper_next global-btn" (click)="addContactDetails()">Save &
        Continue</button>
    </div>
  </form>